// extracted by mini-css-extract-plugin
export default {"Tag":"KZoYDDrc"};